import { Body1 } from '@cian/ui-kit';
import { type FC, type JSX } from 'react';

import styles from './Card.css';

type CardProps = {
  title: string;
  description: JSX.Element | string;
  imageSrc: string;
  imageAlt: string;
};

export const Card: FC<CardProps> = ({ title, description, imageSrc, imageAlt }) => (
  <div className={styles['container']} data-testid="pik-in-numbers-card">
    <img
      alt={imageAlt}
      className={styles['image']}
      data-testid="pik-in-numbers-card-image"
      decoding="async"
      height={163}
      loading="lazy"
      src={imageSrc}
      width={239}
    />
    <div>
      <span className={styles['title']} data-testid="pik-in-numbers-card-title">
        {title}
      </span>
      <Body1 color="text-secondary-default" data-testid="pik-in-numbers-card-description">
        {description}
      </Body1>
    </div>
  </div>
);
